import { createStore, combineReducers, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import { reducer as formReducer } from 'redux-form';
import FDservices from 'reducers/fd-services';

const rootReducer = combineReducers({
  form: formReducer,
  fdData: FDservices
})

const createStoreWithMiddleware = applyMiddleware(ReduxPromise)(createStore);
const store = createStoreWithMiddleware(rootReducer);

export default store;